/* F1B.3C governed mapping and existing resolved-context projection. No entry enrollment or pricing. */
(function(root,factory){
  'use strict';
  if(typeof module==='object'&&module.exports)module.exports=factory();
  else if(!root.NikuyaCartRuntimeAuthority)root.NikuyaCartRuntimeAuthority=factory();
})(typeof globalThis!=='undefined'?globalThis:this,function(){
  'use strict';
  const clone=v=>JSON.parse(JSON.stringify(v));
  const mappingRevision='nikuya-exact-case-20260916';
  const mappings=Object.freeze([
    Object.freeze({heroSku:'NKY000052',heroProductId:'8564385186114',heroVariantId:'49919898485058',caseSku:'NKY000101',caseProductId:'9897246359874',caseVariantId:'50362121290050'}),
    Object.freeze({heroSku:'NKY000051',heroProductId:'8564382859586',heroVariantId:'49919892848962',caseSku:'NKY000100',caseProductId:'9897245802818',caseVariantId:'50362119651650'}),
    Object.freeze({heroSku:'NKY000059',heroProductId:'8532235616578',heroVariantId:'46020210458946',caseSku:'NKY000129',caseProductId:'10007350739266',caseVariantId:'50971463287106'})
  ]);
  function mappingFor(line) {
    for(const m of mappings)for(const kind of ['hero','case'])if(line?.sku===m[kind+'Sku']&&String(line.product_id)===m[kind+'ProductId']&&String(line.variant_id)===m[kind+'VariantId'])return {status:'VERIFIED_IDENTITY',kind,mapping:clone(m),revision:mappingRevision,availability:'UNKNOWN'};
    return {status:'UNRESOLVED_IDENTITY',availability:'UNKNOWN'};
  }
  const integer=n=>Number.isSafeInteger(n)&&n>=0;
  const label=s=>typeof s==='string'&&/^[a-zA-Z0-9_-]{1,80}$/.test(s);
  const stages=Object.freeze({c1:'C1',c2:'C2',c3:'C3',c4:'C4'});
  function createAcquisitionAuthorityProvider({readResolvedContext,registry,readSuppression=()=> 'NO_OVERRIDE',clock=Date.now}={}) {
    async function read() {
      const result=status=>({status,financialEnforcementVerified:false,casePricingVerified:false});
      try {
        const resolved=await readResolvedContext?.();
        if(!resolved?.record)return result('NO_CONTEXT');
        const r=resolved.record,now=clock(),suppression=await readSuppression();
        if(suppression==='SUPPRESS')return result('SUPPRESSED');
        if(!['NO_OVERRIDE','NO OVERRIDE'].includes(suppression))return result('AMBIGUOUS');
        // Same v2 fixed-window/revision contract as F1A.3B restore; no URL/entry API here.
        if(!integer(now)||r.v!==2||r.store!==registry?.store||!label(r.store)||r.family!=='NEW_CUSTOMER_HERO'||
            (typeof r.publicSelector!=='string'||!Object.hasOwn(stages,r.publicSelector))||r.stage!==stages[r.publicSelector]||!label(r.revision)||
            !integer(r.capturedAt)||!integer(r.expiresAt)||r.capturedAt>now||r.expiresAt!==r.capturedAt+604800000)return result('AMBIGUOUS');
        if(now>=r.expiresAt)return result('EXPIRED');
        if(resolved.active!==true)return result('AMBIGUOUS');
        const profile=registry?.revisions?.[r.revision],percentage=r.stage==='C4'?'HERO_15':'HERO_10';
        if(!profile||profile.id!==r.revision||profile.family!==r.family||profile.percentageProfile!==percentage||
            !profile.stages?.includes(r.stage)||profile.ttlMs!==604800000||profile.cartProfile!=='ACQUISITION_COMMON'||
            profile.pdpProfiles?.[r.stage] !== (r.stage+'_NOTICE')||
            !integer(profile.issuedFrom)||r.capturedAt<profile.issuedFrom||
            !['ACTIVE','SUPERSEDED_BUT_HONORED'].includes(profile.status))return result('REVISION_UNSUPPORTED');
        if(profile.status==='ACTIVE'&&(profile.issuedUntil!==null||profile.honorUntil!==null))return result('REVISION_UNSUPPORTED');
        if(profile.status==='SUPERSEDED_BUT_HONORED'&&(!integer(profile.issuedUntil)||profile.issuedUntil<profile.issuedFrom||
            profile.honorUntil!==profile.issuedUntil+profile.ttlMs||r.capturedAt>=profile.issuedUntil||r.expiresAt>profile.honorUntil))return result('REVISION_UNSUPPORTED');
        return {...result('VERIFIED_CONTEXT'),stage:r.stage,revision:r.revision,revisionStatus:profile.status,capturedAt:r.capturedAt,expiresAt:r.expiresAt,
          expectedProfile:r.stage==='C4'?'NKYACQ15':'NKYACQ10',suppression:'NO_OVERRIDE'};
      } catch (_) {return result('AMBIGUOUS')}
    }
    return Object.freeze({read});
  }
  return Object.freeze({createAcquisitionAuthorityProvider,mappingFor,mappings,mappingRevision});
});
